import Phaser from "phaser";
import { SceneName } from "../../constants";

export class GameIntroCut extends Phaser.Scene {
  constructor(config: any) {
    super(config);
  }
  init({ nextLevelKey }: { nextLevelKey: string }) {
    console.log("transition started. Going to key:", nextLevelKey);
  }

  create() {
    const gfx = this.add.graphics();
    gfx.fillStyle(0xffffff);
    gfx.fillRect(0, 0, 128, 128);

    const text = this.add.text(128 / 2, 128 / 2, "SokoBlaster", {
      fontFamily: "Monospace",
      fontSize: 20,
      color: "#101010",
    });
    text.setOrigin(0.5, 0.5);

    this.add.tween({
      targets: [gfx, text],
      alpha: { from: 1, to: 0 },
      delay: 1000,
      duration: 3000,
      onComplete: () => this.scene.remove(SceneName.TransitionGameIntroCut),
      onCompleteScope: this,
    });
  }
}
